// export const api = "http://localhost/rest-api-ase/controllers"; // LocalHost

export const api = "https://ase-fsspx.com/rest-api-ase/controllers"; //Hostinger
